import ApiClient from "core/client";

const client = new ApiClient("/api");

export default client;